import { api } from '@shared/web/api-client';
import type {
  BrandRequest,
  BrandRequestFilter,
  BrandRequestInput,
  BrandRequestReceipt,
  BrandRequestSort,
  BrandRequestStatus,
  BrandRequestsPayload,
  BudgetBand,
} from '@shared/web/types';

interface ListQuery {
  status: BrandRequestFilter;
  budgetBand?: BudgetBand | null;
  search?: string | null;
  sort?: BrandRequestSort;
}

/** The only place the inbound feature talks HTTP. */
export const inboundApi = {
  /**
   * The public form's submit. Unauthenticated — this is the one call in the
   * app that a visitor with no session makes, which is why it lives on a
   * different path from everything below it.
   */
  submit: (input: BrandRequestInput) =>
    api.post<BrandRequestReceipt>('/api/brand-requests', input),

  /** Rows and the chip counts in one request, so the two cannot disagree. */
  list: ({ status, budgetBand, search, sort = 'recent' }: ListQuery) => {
    const params = new URLSearchParams({ status, sort });
    if (budgetBand) params.set('budget', budgetBand);
    if (search) params.set('search', search);
    return api.get<BrandRequestsPayload>(`/api/inbound?${params}`);
  },

  /**
   * Both triage fields go through one call. Status and note are edited in the
   * same pane and usually change together, and splitting them would let a
   * decision save while the reasoning behind it failed to.
   */
  triage: (id: string, patch: { status?: BrandRequestStatus; note?: string | null }) =>
    api.patch<{ request: BrandRequest }>(`/api/inbound/${id}`, patch),
};
